var $b03b45b62a7ccae4$exports = {};
$b03b45b62a7ccae4$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "Selector de culori",
  "colorSwatch": "specimen de culoare",
  "transparent": "transparent",
  "twoDimensionalSlider": "Glisor 2D"
};
export { $b03b45b62a7ccae4$exports as default };